import type { Order } from "../Order.js";
import type { OrderPricesWithUnknownDeliveryPrice } from "../OrderPrices.js";
import { getAppliedVoucherValue } from "./getAppliedVoucherValue.js";

export function getPriceOfOrderWithDiscounts({
	price,
	appliedVoucher,
}: Pick<Order, "appliedVoucher"> & {
	price: OrderPricesWithUnknownDeliveryPrice;
}): {
	voucherValue: number | undefined;
	discountedPrice: number;
} {
	const voucherValue = appliedVoucher ? getAppliedVoucherValue(appliedVoucher, price) : undefined;
	const discountedPrice = price.totalPrice.withTax - (voucherValue ?? 0);
	return { voucherValue, discountedPrice };
}
